module.exports = __webpack_public_path__ + "img/battery_unknown.424d2f74.svg";